// Geofence constants — keep in sync with main.py (GEOFENCE_*) and the iOS
// driver app (src/utils/geofence.ts). The backend is the authority.
export const GEOFENCE_RADIUS_M = 150;
// Most the driver-reported GPS accuracy may widen the fence (m).
export const GEOFENCE_MAX_ACCURACY_ALLOWANCE_M = 100;
// Readings coarser than this (m) earn no allowance and never auto-arrive.
export const GEOFENCE_MAX_USABLE_ACCURACY_M = 250;

export const TASK_STATUS = Object.freeze({
  ASSIGNED: "Assigned",
  EMERGENCY_DISPATCH: "Emergency Dispatch",
  EN_ROUTE: "En Route",
  ARRIVED_PU: "Arrived (PU)",   // arrived at pickup location — two-leg flow
  PICKED_UP: "Picked Up",
  EN_ROUTE_DL: "En Route (DL)", // en route to delivery after pickup — two-leg flow
  ARRIVED: "Arrived",
  DELIVERED: "Delivered",
  COMPLETED: "Completed",
  CANCELED: "Canceled",
  FAILED: "Failed",
  PAUSED: "Paused",
});

export const OVERRIDE_TYPE = Object.freeze({
  PICKUP: "pickup",
  ARRIVAL: "arrival",
  DELIVERY: "delivery",
});

export const TERMINAL_TASK_STATUS_KEYS = new Set([
  TASK_STATUS.DELIVERED.toLowerCase(),
  TASK_STATUS.COMPLETED.toLowerCase(),
  TASK_STATUS.CANCELED.toLowerCase(),
  TASK_STATUS.FAILED.toLowerCase(),
  TASK_STATUS.PAUSED.toLowerCase(),
]);

export function normalizeTaskStatus(status) {
  return String(status || "")
    .toLowerCase()
    .replace(/🚨\s*/g, "")
    .replace(/_/g, " ")
    .trim();
}

export function isPickupPhaseStatus(status) {
  const key = normalizeTaskStatus(status);
  return (
    key === normalizeTaskStatus(TASK_STATUS.ASSIGNED) ||
    key === normalizeTaskStatus(TASK_STATUS.EMERGENCY_DISPATCH) ||
    key === normalizeTaskStatus(TASK_STATUS.EN_ROUTE) ||
    key === normalizeTaskStatus(TASK_STATUS.ARRIVED_PU)
  );
}

export function isDropoffPhaseStatus(status) {
  const key = normalizeTaskStatus(status);
  return (
    key === normalizeTaskStatus(TASK_STATUS.PICKED_UP) ||
    key === normalizeTaskStatus(TASK_STATUS.EN_ROUTE_DL) ||
    key === normalizeTaskStatus(TASK_STATUS.ARRIVED) ||
    key.includes("in transit") ||
    key === "en route delivery"
  );
}

export function isTerminalTaskStatus(status) {
  return TERMINAL_TASK_STATUS_KEYS.has(normalizeTaskStatus(status));
}
